(function (module) {
    'use strict';
    module.factory('reporting.dashboards.services.widgetStatusManager', [
        '$rootScope',
        'utils',
        function ($rootScope, utils) {
            return _.partial(WidgetStatusManager, $rootScope, utils);
        }
    ]);
    function WidgetStatusManager($rootScope, utils, ripsawIds) {
        var self = this;
        this.makeWidgetKey = utils.makeWidgetKey;
        this.widgetStatuses = {};
        var setStartStatus = function (ripsawIds) {
            self.setStatus(ripsawIds, '');
        };
        _.map(ripsawIds, setStartStatus);
        this.setupListeners($rootScope);
    }
    WidgetStatusManager.prototype.setupListeners = function ($rootScope) {
        var listenEvents = [
            'viewresults.widgetFullDataComplete',
            'viewresults.widgetMisconfigured',
            'viewresults.widgetError'
        ];
        var setStatus = _.bind(this.setStatus, this);
        _.map(listenEvents, function (event) {
            $rootScope.$on(event, function (_, widgetId, pageId, containerId) {
                var ripsawIds = {
                    widgetId: widgetId,
                    pageId: pageId,
                    containerId: containerId
                };
                setStatus(ripsawIds, event);
            });
        });
    };
    WidgetStatusManager.prototype.setStatus = function (ripsawIds, status) {
        this.widgetStatuses[this.makeWidgetKey(ripsawIds)] = status;
    };
    WidgetStatusManager.prototype.isReady = function () {
        var readyEvents = [
            'viewresults.widgetFullDataComplete',
            'viewresults.widgetMisconfigured',
            'viewresults.widgetError'
        ];
        var widgetsReady = _.every(this.widgetStatuses, function (status) {
            return readyEvents.indexOf(status) !== -1;
        });
        return widgetsReady;
    };
})(angular.module('reporting.dashboards.services'));
